import { render, staticRenderFns } from "./users-create-page.vue?vue&type=template&id=56fae7ff&scoped=true"
import script from "./users-create-page.vue?vue&type=script&lang=js"
export * from "./users-create-page.vue?vue&type=script&lang=js"
import style0 from "./users-create-page.vue?vue&type=style&index=0&id=56fae7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fae7ff",
  null
  
)

export default component.exports